<template>
  <div class="form-wrapper">
    <h2>Add Supplier</h2>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label>Full Name</label>
        <input v-model="Supplier.name" type="text" placeholder="Supplier Name" required />
      </div>
      <div class="form-group">
        <label>Role</label>
        <input v-model="Supplier.role" type="text" placeholder="Role" required />
      </div>
      <div class="form-group">
        <label>Status</label>
        <select v-model="Supplier.status">
          <option>Active</option>
          <option>Inactive</option>
        </select>
      </div>
      <button class="btn btn-gradient" type="submit">
        <span v-if="loading">Saving...</span>
        <span v-else>Save Supplier</span>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'AddSupplierComponent',
  data() {
    return { Supplier: { name: '', role: '', status: 'Active' }, loading: false };
  },
  methods: {
    submitForm() {
      this.loading = true;
      this.$store.dispatch('Suppliers/addSupplier', this.Supplier)
        .then(() => this.$router.push({ name: 'Suppliers' }))
        .finally(() => this.loading = false);
    }
  }
};
</script>
